import { settingsIcons, sidePannelIcons } from "./SvgIcons";
import {
  hasFeatureEnabled,
  FEATURE_LEVEL,
} from "../../../Diathrive/src/utils/FeatureConstants";

export const WEB_FONTS = {
  "Silka-Regular": require("../../../Diathrive/src/assets/fonts/Silka-Regular.ttf"),
  "Silka-Light": require("../../../Diathrive/src/assets/fonts/Silka-Light.ttf"),
  "Silka-Bold": require("../../../Diathrive/src/assets/fonts/Silka-Bold.ttf"),
  "Silka-SemiBold": require("../../../Diathrive/src/assets/fonts/Silka-SemiBold.ttf"),
  "Silka-Medium": require("../../../Diathrive/src/assets/fonts/Silka-Medium.ttf"),
  "Silka-Black": require("../../../Diathrive/src/assets/fonts/Silka-Black.ttf"),
  "Silka-BlackItalic": require("../../../Diathrive/src/assets/fonts/Silka-BlackItalic.ttf"),
  "Silka-ExtraLightItalic": require("../../../Diathrive/src/assets/fonts/Silka-ExtraLightItalic.ttf"),
  "Silka-ThinItalic": require("../../../Diathrive/src/assets/fonts/Silka-ThinItalic.ttf"),
  "Silka-RegularItalic": require("../../../Diathrive/src/assets/fonts/Silka-RegularItalic.ttf"),
};

//This Store Links might be configured from environment variables in future.
export const PLAYSTORE_LINK =
  "https://play.google.com/store/apps/details?id=com.diathrive.app.android";

export const APPSTORE_LINK =
  "https://apps.apple.com/us/app/diathrive-health/id1619849670";

export const SIDE_PANNEL_TEXT = {
  HOME: "Home",
  BLOOD_SUGAR_READINGS: "Blood Sugar Readings",
  RESOURCES: "Resources",
  STORE: "Store",
  ADVISING: "Advising",
  SETTINGS: "Settings",
  HELP: "Contact Support",
};

export const SIDE_PANNEL_ITEMS = [
  [
    {
      id: 1,
      Icon: sidePannelIcons.home,
      ActiveIcon: sidePannelIcons.homeActive,
      text: SIDE_PANNEL_TEXT.HOME,
      url: "/home",
    },
    {
      id: 2,
      Icon: sidePannelIcons.bloodSugar,
      ActiveIcon: sidePannelIcons.bloodSugarActive,
      text: SIDE_PANNEL_TEXT.BLOOD_SUGAR_READINGS,
      url: "/blood-sugar-readings",
    },
    {
      id: 3,
      Icon: sidePannelIcons.resources,
      ActiveIcon: sidePannelIcons.resourcesActive,
      text: SIDE_PANNEL_TEXT.RESOURCES,
      url: "/resources",
    },
    {
      id: 4,
      Icon: sidePannelIcons.store,
      ActiveIcon: sidePannelIcons.storeActive,
      text: SIDE_PANNEL_TEXT.STORE,
      url: "/store",
    },
    ...(hasFeatureEnabled(FEATURE_LEVEL.advisingEnabled)
      ? [
          {
            id: 7,
            Icon: sidePannelIcons.advising,
            ActiveIcon: sidePannelIcons.advisingActive,
            text: SIDE_PANNEL_TEXT.ADVISING,
            url: "/advising",
          },
        ]
      : []),
  ],
  [
    {
      id: 5,
      Icon: sidePannelIcons.settings,
      ActiveIcon: sidePannelIcons.settingActive,
      text: SIDE_PANNEL_TEXT.SETTINGS,
      url: "/settings",
    },
    {
      id: 6,
      Icon: sidePannelIcons.help,
      ActiveIcon: sidePannelIcons.helpActive,
      text: SIDE_PANNEL_TEXT.HELP,
      url: "/contact-support",
    },
  ],
];

export const SETTINGS_TILES = [
  {
    id: 1,
    icon: settingsIcons.profile,
    header: "My Profile",
    description:
      "Manage your personal information. Update your name, avatar, password, etc.",
  },
  {
    id: 3,
    icon: settingsIcons.address,
    header: "My Addresses",
    description: "Manage your related addresses for shipping and billing.",
  },
  {
    id: 4,
    icon: settingsIcons.sugarRange,
    header: "My Blood Sugar Range",
    description:
      "Track your diabetes status by defining your blood sugar ranges.",
  },
  {
    id: 5,
    icon: settingsIcons.contacts,
    header: "My Contacts",
    description:
      "Add your family, friends and doctors to you personal contact list at Diathrive Health.",
  },
  // {
  //   id: 6,
  //   icon: settingsIcons.devices
  //   header: "Connected Devices",
  //   description:
  //     "Connect your phone to your glucose monito device. Available only on Diathrive’s Mobile App.",
  // },
];

export const CONTACTS = [
  {
    firstname: "Mom",
    lasrname: "",
    phone: "(405) 555-0128",
    email: "kathryn.bm.84@gmail.com",
  },
  {
    firstname: "Dr.Jacob",
    lastname: "Jones",
    phone: "(405) 555-0128",
    email: "kathryn.bm.84@gmail.com",
  },
];
